// This is how a normal module looks like. You can copy paste this
// for any new module you want to create. Then you can import it in
// main.js and call 'init()' to execute the code.


const Map = ((($) => {
  let Map;
  let MapMarker;
  let Project;
  let ProjectID;
  function init() {
    $(this);
    //Map = $('.Map');
    MapMarker = $('.Map-marker');
    Project = $('.Project');
    Project.on({
      mouseenter: function() {
        Map = $(this).attr('data-map');
        $('.Map-point').css({'background-image':'url(' + Map + ')', 'opacity':'1'});
      },
      mouseleave: function() {
        $('.Map-point').css({'background-image':'', 'opacity':'0'});
      }
    });
    MapMarker.on({
      mouseenter: function() {
        Map = $(this).attr('data-map');
        ProjectID = $(this).attr('data-project');
        $('.Map-point').css({'background-image':'url(' + Map + ')', 'opacity':'1'});
        $('#'+ProjectID).addClass('active');
      },
      mouseleave: function() {
        $('.Map-point').css({'background-image':'', 'opacity':'0'});
        $('#'+ProjectID).removeClass('active');
      }
    });
  }

  return {
    init
  };
}))(jQuery);

export default Map;



// WEBPACK FOOTER //
// ./src/static/js/modules/map.js